import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';
import { fetchApi } from '@/config/axiosSetting';
import { DriverLicenceInfoParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchDriverLicenceInfo/driverLicenceInfoQuery.type';

export const driverLicenceInfoQueryFunction = (
  params: DriverLicenceInfoParamsType,
) => {
  const formattedParams = {
    ...params.data,
    license_issue_date: convertPersianToGregorian(
      params.data.license_issue_date?.toString() ?? '',
    ),
    license_issue_location_country: Number(
      params.data.license_issue_location_country.value,
    ),
    license_type: Number(params.data.license_type.value),
  };
  return fetchApi.patch(
    `/property/reports/${params.id}/accident_users/damaged/user_information/driver/certificate_information/`,
    formattedParams,
    {
      params: {
        damaged_id: params?.damaged_id,
        id: params?.id,
      },
    },
  );
};
